export class NotificationStepData {
    stepData_ = null;
    constructor(
        public id: string,
        public onRunning,
        public onEnded,
    ) {}

    onMessage(data) {
        // debugger;
        // console.log("onMessage")
        console.log(data);
        // console.log(this.id)
        if (data?.id === this.id) {
            if (data.extraPayload?.step >= data.extraPayload?.stepCount) {
                this.stepData_ = null;
                if (this.onEnded) {
                    this.onEnded();
                } else {
                    debugger;
                }
            } else {
                this.stepData_ = data.extraPayload;
                if (this.onRunning) {
                    this.onRunning();
                } else {
                    debugger;
                }
            }
        }
    }

    get stepData() {
        if (this.stepData_) {
            return this.stepData_;
        }
        return {
            action: "",
            step: 0,
            stepCount: 5,
        };
    }

    get progressValue() {
        return (100 * this.stepData.step) / this.stepData.stepCount;
    }

    get action() {
        return this.stepData.action;
    }

    get title() {
        return this.stepData.title || "XXXX";
    }
}
